
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/app/shared/constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinesscardService {

  constructor(private http: HttpClient) { }

  Baseurl(): string {
    return Constants.BASE_URL;
  }
  // Update Business Items Price
  //GetCorporateCustomerList
  getCustomerList(ID): Observable<any> {
    return this.http.get<any>(Constants.BASE_URL + 'Quotation/GetCorporateCustomerList/' + ID);
  }
  // UpdateCustomerPrice
  updateCustomerPrice(data) {
    return this.http.post<any>(Constants.BASE_URL + 'Quotation/UpdateCustomerPrice', data, { observe: 'response' });
  }
  // Quotation/GetCustomerPrice
  getCustomerPrice(data) {
    return this.http.post<any>(Constants.BASE_URL + 'Quotation/GetCustomerPrice', data, { observe: 'response' });
  }
  // Create Business Cart
  // Quotation/GetBusinessCardCustomers/3
  getBusinessCardCustomers(ID: number): Observable<any>{
    return this.http.get<any>(Constants.BASE_URL + 'Quotation/GetBusinessCardCustomers/' + ID);
  }
  //Quotation/GetBusinessCardCustomer
  getBusinessCardCustomer(data): Observable<any> {
    return this.http.post<any>(Constants.BASE_URL + 'Quotation/GetBusinessCardCustomer', data, { observe: 'response' });
  }
  // /Api/Quotation/UpdateCustomerBusienssCard
  updateCustomerBusienssCard(data) {
    return this.http.post<any>(Constants.BASE_URL + 'Quotation/UpdateCustomerBusienssCard', data, { observe: 'response' });
  }

   //Quotation/GetCustomerPriceByQRCode
   getCustomerPriceByQRCode(data): Observable<any> {
    return this.http.post<any>(Constants.BASE_URL + 'Quotation/GetCustomerPriceByQRCode', data, { observe: 'response' });
  }


}
